import type { MentorshipApplyClosedReason } from '@/shared/job-mentorship';

export function mentorshipApplyClosedLabel(
  reason: MentorshipApplyClosedReason | null | undefined
): string {
  switch (reason) {
    case 'inactive':
      return 'Энэ хөтөлбөр идэвхгүй байна.';
    case 'before_start':
      return 'Бүртгэл хараахан эхлээгүй байна.';
    case 'after_apply_until':
      return 'Хөтөлбөр дууссан байна.';
    case 'after_program_end':
      return 'Хөтөлбөр дууссан байна.';
    default:
      return 'Бүртгэл хаалттай байна.';
  }
}
